import ExtensionIcon from '@mui/icons-material/Extension';
import CardsGridSubmenu from '../../../common/components/cardsGrid/cardsGridSubmenu';
import BasicLayout from '../../../common/layouts/basicLayout';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { CardsGridItem } from '../../../common/components/cardsGrid/cardsGrid';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DownloadIcon from '@mui/icons-material/Download';
import ImportExportIcon from '@mui/icons-material/ImportExport';

const cover: CardsGridItem = {
  title: 'Martins-Log',
  icon: AssessmentIcon,
  path: '/integracao',
};

const gridItems: CardsGridItem[] = [
  {
    title: 'EDI',
    icon: DriveFileRenameOutlineIcon,
    path: '/integracao/martins-log/edi',
  },
  {
    title: 'BrookerFeed',
    icon: DriveFileRenameOutlineIcon,
    path: '/integracao/martins-log/brookerFeed',
  },
  {
    title: 'Import Report',
    icon: DownloadIcon,
    path: '/integracao/martins-log/importReport',
  },
  {
    title: 'Export Report',
    icon: DownloadIcon,
    path: '/integracao/martins-log/exportReport',
  },
  {
    title: 'Saida EDI',
    icon: DriveFileRenameOutlineIcon,
    path: '/integracao/martins-log/saidaEdi',
  },
];

const MartinsLogPage = () => {
  return (
    <BasicLayout title={'Martins-Log'} icon={<ExtensionIcon color={'secondary'} />}>
      <CardsGridSubmenu cover={cover} items={gridItems}></CardsGridSubmenu>
    </BasicLayout>
  );
};

export default MartinsLogPage;
